module.exports = __webpack_public_path__ + "img/sports_bottom.8e7576c4.jpg";